module.exports = "images/3-way-switch-rect-9614cb0fc1aa2faac53d570b5e060954.png";